module.exports = __webpack_public_path__ + "assets/img/79f3ea01a3d77a6937c6dfba4b90f400.svg";